module.exports = __webpack_public_path__ + "img/logo.a03215d1.png";